var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "33",
        height: "26",
        viewBox: "0 0 33 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M29.9062 4.33333H17.5312L13.4062 0H3.09375C1.3851 0 0 1.45505 0 3.25V22.75C0 24.5449 1.3851 26 3.09375 26H29.9062C31.6149 26 33 24.5449 33 22.75V7.58333C33 5.78839 31.6149 4.33333 29.9062 4.33333Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }